export function normalizeRewardResellPrice(
  value: unknown,
): number | undefined {
  if (value === '' || value === null || value === undefined) return undefined;

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return undefined;

  return Math.max(0, Math.floor(parsed));
}
